import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            福利分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大福利类目，精准找到你需要的优惠与权益
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-background-100 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg ${
                cat.color === 'primary' ? 'bg-primary-100' : 'bg-accent-100'
              }`}>
                <i className={`${cat.icon} text-xl ${
                  cat.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
                }`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 篇福利攻略
                </span>
              </div>
              <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-300 group-hover:text-primary-400 transition-colors mt-3">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}